<template>
  <Modal
    v-bind="{ padded: false, split, canClose, active, scope, yScroll }"
    @close="$emit('close')"
  >
    <template v-if="split">
      <div class="split-left relative md-lg:h-full overflow-y-auto ">
        <!-- scroll overflow container -->
        <div
          class="flex flex-col justify-center p-4 md-lg:px-10 md-lg:pt-7 md-lg:pb-5 w-full text-center min-h-full"
        >
          <slot name="left" />
        </div>
      </div>
      <div
        class="split-right relative overflow-y-auto overflow-x-hidden"
        :class="{
          'order-first md-lg:order-last restrict-height': reverseOnMobile,
          'md-lg:border-l': showDivider,
        }"
      >
        <slot name="right" />
      </div>
    </template>
    <template v-if="!split">
      <slot name="left" />
      <slot name="right" />
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/modals/Modal'

export default {
  components: { Modal },
  props: {
    reverseOnMobile: {
      type: Boolean,
      default: true,
    },

    canClose: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    scope: {
      type: String,
      required: true,
    },

    padding: {
      type: String,
      default: 'p-0',
    },

    split: {
      type: Boolean,
      default: true,
    },

    showDivider: {
      type: Boolean,
      default: false,
    },

    yScroll: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState(['flags']),
  },
}
</script>

<style lang="scss" scoped>
.split-left {
  @apply w-full;

  @screen md-lg {
    width: 55%;
  }
}
.split-right {
  @apply w-full;

  &.restrict-height {
    @apply h-full max-h-80;

    min-height: 12rem;

    @screen md-lg {
      @apply max-h-full;

      min-height: initial;
    }
  }

  @screen md-lg {
    width: 45%;
  }
}
</style>
